import type { KPIData } from "./types";

export const formatKPIValue = (kpi?: KPIData) => {
  if (!kpi) return "";

  const { value, decimalPlaces = 2, prefix = "", suffix = "%" } = kpi;
  const formattedValue = value?.toFixed(decimalPlaces).replace(".", "/");

  return `${prefix}${formattedValue}${suffix}`;
};
